import React, { useEffect, useState } from "react";
import { Button, Empty, message } from "antd";
import { Footer, Sidebar } from "../../../../components";
import { getGraphData } from "../../../../utils/api";
import VisualisationDropdowns from "./VisualisationDropdowns";

const DefaultVisualisationDashboard = ({
  currentOrg,
  setCurrentOrg,
  orgData,
  setOrgData,
  orgLoading,
  setOrgLoading,
  siteData,
  setSiteData,
  currentSite,
  setCurrentSite,
  siteLoading,
  setSiteLoading,
  currentCrop,
  setCurrentCrop,
  cropLoading,
  setCropLoading,
  cropData,
  setCropData,
  searchParams,
  setSearchParams,
  settingDefaults,
  setSettingDefaults,
}) => {
  const [messageApi, contextHolder] = message.useMessage();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [siteMetadata, setSiteMetadata] = useState([]);
  const [currentGreenhouse, setCurrentGreenhouse] = useState(null);
  const [currentPlot, setCurrentPlot] = useState(null);
  const [plotData, setPlotData] = useState([]);
  const [greenhouseData, setGreenhouseData] = useState([]);
  const [currentDate, setCurrentDate] = useState(null);
  const [dropdownLoading, setDropdownLoading] = useState(false);
  const [graphLoading, setGraphLoading] = useState(false);
  const [dateData, setDateData] = useState([]);
  const [headSizeGraphData, setHeadSizeGraphData] = useState({});
  const [standCountGraphData, setStandCountGraphData] = useState({});
  const [activeTab, setActiveTab] = useState("headSize");

  const distinguishAndSetGraphData = (data) => {
    const headSizeGraphData = {};
    const standCountGraphData = {};
    let activeTab = "standCount";

    Object.entries(data).forEach(([date, value]) => {
      const keys = Object.keys(value);
      const hasStandCount = keys.some(
        (key) => key.toLowerCase() === "standcount",
      );
      if (hasStandCount) {
        standCountGraphData[date] = value;
      } else {
        headSizeGraphData[date] = value;
        activeTab = "headSize";
      }
    });
    setHeadSizeGraphData(headSizeGraphData);
    setStandCountGraphData(standCountGraphData);
    setActiveTab(activeTab);
  };

  // Fetch graph data
  const fetchGraphData = async () => {
    setGraphLoading(true);
    try {
      const graphRes = await getGraphData(
        currentOrg,
        currentSite.id,
        currentCrop.id,
        currentPlot.id,
        null,
        currentGreenhouse.id,
      );
      const data = graphRes?.data?.data?.[currentPlot.name] || [];
      const grapDataDateWise = {};
      data.forEach((dateWiseData) => {
        grapDataDateWise[dateWiseData.harvest_date] = dateWiseData.data;
      });
      distinguishAndSetGraphData(grapDataDateWise);
    } catch (err) {
      const msg =
        err?.response?.data?.detail || "Oops! Error fetching graph data!";
      messageApi.open({
        type: "error",
        content: msg,
      });
    } finally {
      setGraphLoading(false);
    }
  };

  useEffect(() => {
    if (currentPlot && currentDate && !dropdownLoading) {
      fetchGraphData();
    }
  }, [currentPlot, currentDate, dropdownLoading]);

  return (
    <>
      <div id="dashboard">
        <Sidebar
          active="visualisation"
          open={sidebarOpen}
          setOpen={setSidebarOpen}
        />
        <div
          className={`flex flex-col w-full px-20 ${
            sidebarOpen ? "pl-60 sm:pl-10" : "sm:pl-14"
          } pt-10 md:pt-4 pb-14 md:pl-15 md:pr-2 sm:pr-4 justify-center transition-padding ease-in-out duration-200`}
        >
          <VisualisationDropdowns
            siteMetadata={siteMetadata}
            setSiteMetadata={setSiteMetadata}
            currentOrg={currentOrg}
            setCurrentOrg={setCurrentOrg}
            orgData={orgData}
            setOrgData={setOrgData}
            orgLoading={orgLoading}
            setOrgLoading={setOrgLoading}
            currentSite={currentSite}
            setCurrentSite={setCurrentSite}
            siteData={siteData}
            setSiteData={setSiteData}
            siteLoading={siteLoading}
            setSiteLoading={setSiteLoading}
            currentCrop={currentCrop}
            setCurrentCrop={setCurrentCrop}
            cropData={cropData}
            setCropData={setCropData}
            cropLoading={cropLoading}
            setCropLoading={setCropLoading}
            currentPlot={currentPlot}
            setCurrentPlot={setCurrentPlot}
            currentGreenhouse={currentGreenhouse}
            setCurrentGreenhouse={setCurrentGreenhouse}
            greenhouseData={greenhouseData}
            setGreenhouseData={setGreenhouseData}
            plotData={plotData}
            setPlotData={setPlotData}
            currentDate={currentDate}
            setCurrentDate={setCurrentDate}
            setDropdownLoading={setDropdownLoading}
            searchParams={searchParams}
            setSearchParams={setSearchParams}
            settingDefaults={settingDefaults}
            setSettingDefaults={setSettingDefaults}
            dateData={dateData}
            setDateData={setDateData}
          />
          {Object.keys(siteMetadata).length === 0 && !dropdownLoading ? (
            <div className="text-2xl text-center">Metadata not Configured!</div>
          ) : (
            <div>
              <div className="flex flex-col">
                <Empty description="Work in Progress !!!"></Empty>
              </div>
            </div>
          )}
        </div>
        <Footer sidebarOpen={sidebarOpen} />
      </div>
    </>
  );
};

export default DefaultVisualisationDashboard;
